import React from 'react';
import { PropTypes } from 'prop-types';
import { Row, Col } from 'antd';
import InputComponent from './InputComponent';
import { connect } from 'react-redux';
import { setSuccessorValues, jsonTemp } from '../../actions';
import { ErrMargin } from '../styles';
import { validationHandler, toggleStepTwoUpdateButton } from '../../actions';
import FormItem from 'antd/lib/form/FormItem';
import { MarginSpecific } from '../../../../MyAccounts/Components/Step2LegacyOptions/Components/styles';
import { EmailWrapper } from '../../../../MyAccounts/Components/Step1Setup/styles';
import { SpanWrap, PercentageTitle } from '../../../../MyAccounts/Components/Step2LegacyOptions/styles';
import { RadioButtonWrapper } from '../../Step1Setup/styles';
import { SelectComponentWrap } from './Tabs/styles';
import SelectComponent from './SelectComponent';
import { CommonInfoDerivedStates } from '../../selectors';
import { RadioButton } from '../../../../../CommonComponents/commonStyles';

export const handleBlur = (props, e, type, successors) => {
	let arr = successors;
	if (arr.length > 0) {
		arr.forEach(val => {
			if (val.key == props.successorKey) {
				if (type.toLowerCase().includes('charity')) {
					if (val.name == '') {
						val.charityNameError = <ErrMargin>Please enter charity name</ErrMargin>;
					} else if (val.name.length > 0 && val.name.length < 2) {
						val.charityNameError = (
							<ErrMargin>Charity Name is too short. Please correct to proceed</ErrMargin>
						);
					} else {
						val.charityNameError = null;
					}
				} else if (type.toLowerCase().includes('phone')) {
					val.phoneError = null;
				} else if (type.toLowerCase().includes('allocpercent')) {
					if (val.charityAllocPercent === '') {
						val.charityAllocPercentError = <ErrMargin>Please enter % of charity</ErrMargin>;
					}
				} else if (type.toLowerCase().includes('recognition')) {
					if (val.grantRecognition === '') {
						val.grantRecognitionError = <ErrMargin>Grant recognition required</ErrMargin>;
					}
				} else if (type.toLowerCase().includes('othertext')) {
					if (val.otherGrantPurposeText === '') {
						val.otherGrantPurposeTextError = <ErrMargin>Grant purpose required</ErrMargin>;
					}
				} else if (type.toLowerCase().includes('email')) {
					let reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
					if (!reg.test(val.contactEmail) && val.contactEmail != '') {
						val.emailError = <ErrMargin>Email address should follow the format x@x.x</ErrMargin>;
					} else {
						val.emailError = null;
					}
				}
			}
		});
	}
	if (props.isStep2Edit) {
		let tempData = props.tempData.tempJSON;
		if (props.contentKey == 1 || props.contentKey == 2) {
			tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
		} else {
			tempData.legacyOptions[props.contentKey - 1].successionPlanGranteeOrg = arr;
		}
		props.jsonTemp({
			tempJSON: tempData,
			enableReset: true,
		});
	} else {
		props.setSuccessorValues({
			successorAdvisor: arr,
			key: props.contentKey,
			successorKey: props.successorKey - 1,
		});
	}
};

export const handleChange = (props, e, type, successors) => {
	if (props.stepperUpdateIndex.status) {
		props.toggleStepTwoUpdateButton(true);
	}
	let arr = successors;
	if (arr.length > 0) {
		arr.forEach(val => {
			if (val.key == props.successorKey) {
				if (type.toLowerCase().includes('charity')) {
					if (e.target.value.length > 0) {
						val.charityNameError = null;
					}
					val.name = e.target.value;
				} else if (type.toLowerCase().includes('first')) {
					val.contactFirstName = e.target.value;
				} else if (type.toLowerCase().includes('last')) {
					val.contactLastName = e.target.value;
				} else if (type.toLowerCase().includes('web')) {
					val.webAddress = e.target.value;
				} else if (type.toLowerCase().includes('phone')) {
					val.phoneError = null;
					val.contactPhone = e.target.value;
				} else if (type.toLowerCase().includes('email')) {
					if (e.target.value.length > 0) {
						val.emailError = null;
					}
					val.contactEmail = e.target.value;
				} else if (type.toLowerCase().includes('ein')) {
					let reg = /^[0-9a-zA-Z!#$%^&*]{0,10}$/;
					if (reg.test(e.target.value)) {
						val.ein = e.target.value;
					}
				} else if (type.toLowerCase().includes('alloc')) {
					if (e.target.value.length < 4) {
						let regPercent = /^(\s*|^[1-9][0-9]?$|^100$)$/;
						if (regPercent.test(e.target.value)) {
							val.charityAllocPercent = e.target.value;
							val.charityAllocPercentError = null;
							val.multipleCharitiesError = null;
						}
					}
				} else if (type.toLowerCase().includes('purpose')) {
					val.grantPurpose = e.target.value;
					val.otherGrantPurposeTextError = null;
				} else if (type.toLowerCase().includes('othertext')) {
					val.otherGrantPurposeText = e.target.value;
					val.otherGrantPurposeTextError = null;
				} else if (type.toLowerCase().includes('recognition')) {
					val.grantRecognition = e;
					val.grantRecognitionError = null;
				}
			}
		});
	}

	if (props.isStep2Edit) {
		let tempData = props.tempData.tempJSON;
		if (props.contentKey == 1 || props.contentKey == 2) {
			tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
		} else {
			tempData.legacyOptions[props.contentKey - 1].successionPlanGranteeOrg = arr;
		}
		props.jsonTemp({
			tempJSON: tempData,
			enableReset: true,
		});
	} else {
		props.setSuccessorValues({
			successorAdvisor: arr,
			key: props.contentKey,
			successorKey: props.successorKey - 1,
		});
	}
};

export const CharityBasicInfo = props => {
	let successors;
	if (props.isStep2Edit) {
		if (props.contentKey == 1 || props.contentKey == 2) {
			successors = props.tempData.tempJSON.legacyOptions[props.contentKey - 1].successorAdvisor;
		} else {
			successors = props.tempData.tempJSON.legacyOptions[props.contentKey - 1].successionPlanGranteeOrg;
		}
	} else {
		successors = props.legacy.legacyOptions[props.contentKey - 1].successorAdvisor.successorAdvisor;
	}
	return (
		<div>
			{successors[successors.length - 1].multipleCharitiesError
				? successors[successors.length - 1].multipleCharitiesError
				: null}
			<Row>
				<Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
					<InputComponent
						title="Charity Name"
						name="name"
						placeholder="Enter charity name"
						data-test="charity-name"
						handleBlur={e => handleBlur(props, e, 'charity Name', successors)}
						handleInputChange={e => handleChange(props, e, 'charity Name', successors)}
						value={successors[props.successorKey - 1].name}
						max={150}
						role="textbox"
						aria-label="Charity Name"
						id="txtCharityName"
					/>
					{successors[props.successorKey - 1].charityNameError
						? successors[props.successorKey - 1].charityNameError
						: null}
				</Col>
				<Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
					<InputComponent
						title="% to grant to charity"
						placeholder="Enter % to grant to charity"
						name="charityAllocPercent"
						data-test="alloc-percent"
						handleBlur={e => handleBlur(props, e, 'allocpercent', successors)}
						handleInputChange={e => handleChange(props, e, 'allocpercent', successors)}
						value={successors[props.successorKey - 1].charityAllocPercent}
						id="txtCharityAllocPercent"
						role="textbox"
						aria-label="grant to charity"
					/>
					{successors[props.successorKey - 1].charityAllocPercentError
						? successors[props.successorKey - 1].charityAllocPercentError
						: null}
				</Col>
			</Row>
			<Row>
				<Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
					<InputComponent
						title="EIN (Optional)"
						data-test="enter-ein"
						placeholder="Enter EIN"
						handleInputChange={e => handleChange(props, e, 'ein', successors)}
						value={successors[props.successorKey - 1].ein}
						id="txtEin"
						role="textbox"
						aria-label="Enter EIN"
					/>
				</Col>
				<Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
					<InputComponent
						handleBlur={e => handleBlur(props, e, 'Phone number', successors)}
						title="Contact Phone Number (Optional)"
						placeholder="Enter number"
						data-test="enter-number"
						handleInputChange={e => handleChange(props, e, 'phone number', successors)}
						value={successors[props.successorKey - 1].contactPhone}
						id="txtPhoneNumber"
						role="textbox"
						aria-label="Contact"
					/>
				</Col>
			</Row>

			<Row>
				<Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
					<InputComponent
						handleBlur={e => handleBlur(props, e, 'Email', successors)}
						title="Contact Email (Optional)"
						placeholder="Enter email"
						data-test="enter-email"
						handleInputChange={e => handleChange(props, e, 'email', successors)}
						value={successors[props.successorKey - 1].contactEmail}
						id="txtEmail"
						role="textbox"
						aria-label="Contact Email"
					/>
				</Col>
				<Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
					<InputComponent
						title="Contact Web Address (Optional)"
						placeholder="Enter Web Address"
						name="webAddress"
						data-test="enter-web-address"
						handleInputChange={e => handleChange(props, e, 'web', successors)}
						value={successors[props.successorKey - 1].webAddress}
						id="txtWebAddress"
						role="textbox"
						aria-label="Contact Web"
					/>
				</Col>
			</Row>

			<Row>
				<Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
					<InputComponent
						title="Contact First Name (Optional)"
						placeholder="Enter Name"
						data-test="enter-first-name"
						handleInputChange={e => handleChange(props, e, 'first Name', successors)}
						value={successors[props.successorKey - 1].contactFirstName}
						id="txtFirstName"
						role="textbox"
						aria-label="Contact First"
					/>
				</Col>
				<Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
					<InputComponent
						title="Contact Last Name (Optional)"
						placeholder="Enter Name"
						data-test="enter-last-name"
						handleInputChange={e => handleChange(props, e, 'last Name', successors)}
						value={successors[props.successorKey - 1].contactLastName}
						id="txtlastName"
						role="textbox"
						aria-label="Contact Last"
					/>
				</Col>
			</Row>
			<Row>
				<Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
					<SelectComponentWrap>
						<SelectComponent
							title="Grant Recognition"
							aria-label="Grant Recognition"
							data-test="enter-grant-recognition"
							placeholder="-Select-"
							showArrow={true}
							name="grantRecognition"
							handleBlur={e => handleBlur(props, e, 'recognition', successors)}
							id={`grantRecognition${props.successorKey}${props.contentKey}`}
							data={[{ desc: 'Anonymous' }, { desc: 'Account Name only' }]}
							showArrow={true}
							handleInputChange={e => handleChange(props, e, 'recognition', successors)}
							value={
								successors[props.successorKey - 1].grantRecognition
									? successors[props.successorKey - 1].grantRecognition
									: undefined
							}
						/>
						{successors[props.successorKey - 1].grantRecognitionError
							? successors[props.successorKey - 1].grantRecognitionError
							: ''}
					</SelectComponentWrap>
				</Col>
				<Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
					<FormItem>
						<MarginSpecific paddingTop="2px">
							<EmailWrapper>
								<PercentageTitle>Grant Purpose</PercentageTitle>
							</EmailWrapper>
						</MarginSpecific>
						<RadioButtonWrapper
							name="grantPurpose"
							data-test="enter-grant-purpose"
							onChange={e => handleChange(props, e, 'purpose', successors)}
							value={successors[props.successorKey - 1].grantPurpose}
							id="rdgrantPurpose"
						>
							<SpanWrap>
								<RadioButton value="AOMN">Area of most need</RadioButton>
							</SpanWrap>
							<SpanWrap>
								<RadioButton value="OTHER">Other</RadioButton>
							</SpanWrap>
						</RadioButtonWrapper>
						{successors[props.successorKey - 1].grantPurpose === 'OTHER' ? (
							<InputComponent
								placeholder="Enter Grant Purpose"
								name="otherGrantPurposeText"
								handleInputChange={e => handleChange(props, e, 'othertext', successors)}
								handleBlur={e => handleBlur(props, e, 'othertext', successors)}
								value={successors[props.successorKey - 1].otherGrantPurposeText}
							/>
						) : null}
					</FormItem>
					{successors[props.successorKey - 1].otherGrantPurposeTextError
						? successors[props.successorKey - 1].otherGrantPurposeTextError
						: ''}
				</Col>
			</Row>
		</div>
	);
};

const mapStateToProps = state => ({
	legacy: state.getIn(['npaFormReducer', 'legacyOptions', 'legacyOptions']),
	...CommonInfoDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
	setSuccessorValues: val => dispatch(setSuccessorValues(val)),
	jsonTemp: val => dispatch(jsonTemp(val)),
	validationHandler: val => dispatch(validationHandler(val)),
	toggleStepTwoUpdateButton: val => dispatch(toggleStepTwoUpdateButton(val)),
});

CharityBasicInfo.propTypes = {
	contentKey: PropTypes.number,
	isStep2Edit: PropTypes.any,
	jsonTemp: PropTypes.func,
	legacy: PropTypes.object,
	setSuccessorValues: PropTypes.func,
	stepperUpdateIndex: PropTypes.any,
	successorKey: PropTypes.string,
	tempData: PropTypes.any,
	toggleStepTwoUpdateButton: PropTypes.func,
	validationHandler: PropTypes.func,
}
	
	export default connect(mapStateToProps, mapDispatchToProps)(CharityBasicInfo);
